import { Component } from "@angular/core";

@Component({
  selector: "app-detail-main-template",
  templateUrl: "./detail-main-template.component.html",
  styleUrls: ["./detail-main-template.component.scss"],
})
export class DetailMainTemplateComponent {}
